import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Store } from '@components/stores-locator/model';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StoresService extends ApiServiceBase<Store> {
  private readonly stores$: ReplaySubject<Store[]>;
  private readonly storesVisible$: ReplaySubject<Set<string>>;
  private readonly urlAppointment$: ReplaySubject<string>;

  constructor() {
    super('stores');
    this.stores$ = new ReplaySubject<Store[]>(1);
    this.storesVisible$ = new ReplaySubject<Set<string>>(1);
    this.urlAppointment$ = new ReplaySubject<string>(1);
  }

  getStores$(): Observable<Store[]> {
    return this.stores$;
  }

  setStores(stores: Store[]): void {
    this.stores$.next(stores);
  }

  getStoresVisible$(): ReplaySubject<Set<string>> {
    return this.storesVisible$;
  }

  setStoresVisible(stores: Set<string>): void {
    this.storesVisible$.next(stores);
  }

  getUrlAppointment$(): ReplaySubject<string> {
    return this.urlAppointment$;
  }

  setUrlAppointment(urlAppointment: string): void {
    this.urlAppointment$.next(urlAppointment);
  }
}
